export enum EnumRunPhase {
  CONTEXT = 'context',
  CONNECTING = 'connecting',
  MODEL = 'model',
  FINALIZING = 'finalizing'
}
